export const NAME = 'uwbRoom';
